import { Box, BoxProps, Card, Flex, Text } from "@radix-ui/themes"
import React, { ComponentProps } from "react"
import Avatar from "./avatar-render"
import { IMessage } from "../../../core/types/services-types/messages-types"
import moment from "moment"


export interface ChatRenderProps {
    data: IMessage,
	onClickCard: (chatId: number | string) => void,
    style?: React.CSSProperties,
}



export default function ChatCardRender(props: ChatRenderProps) {
    const {data, onClickCard, style} = props
    return (
        <Box className="hover:shadow-xl transition-shadow cursor-pointer rounded-none" style={{...style}} onClick={e => onClickCard(data.chat_companion.id)}>
	<Card className="border-none" style={{border: 'none'}}>
		<Flex gap="3" align="center">
              <Avatar name={data.chat_companion.login} />
			<Box>
				<Text as="div" size="2" weight="bold">
					{data.chat_companion.login}
				</Text>
				<Text as="div" size="2" color="gray">
					{data.message.substring(0, 30)}...
				</Text>
			</Box>
            <Text as="div" size="2" color="gray">
					{moment(data.updatedAt).format('DD:MM:YYYY HH:mm')}
				</Text>
		</Flex>
	</Card>
</Box>
    )
}